import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { GenerativeAIServiceTick } from "../../../app-constants";
import { Link } from "gatsby";

function Cmsserviceworkflow() {
  return (
    <section className="cms_service_workflow p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={7}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              Our CMS Development Services <span>Workflow</span>
            </h2>
            <p>
              Our CMS development company follows a lean, agile process to plan,
              design, and deploy to ensure that every launch is high-performing
              and valuable for your modern digital marketing infrastructure.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">01</div>
                <div className="cms-service-head">
                  <h5>Requirements Analysis</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>
                Gather business needs, define scope, and establish requirements
                for a customized CMS solution.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">02</div>
                <div className="cms-service-head">
                  <h5>Planning Stage</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>
                Develop a project roadmap, allocate resources, and set timelines
                for each development phase.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">03</div>
                <div className="cms-service-head">
                  <h5>Architecture Design</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>
                Create scalable, secure architecture focusing on headless CMS
                and microservices.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">04</div>
                <div className="cms-service-head">
                  <h5>Design Stage</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>
                Design wireframes and mockups, emphasizing user interface and
                experience.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">05</div>
                <div className="cms-service-head">
                  <h5>Development Stage</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>
                Code custom features, integrate APIs, and implement the CMS
                architecture for scalability.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">06</div>
                <div className="cms-service-head">
                  <h5>Testing & QA Stage</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>
                Conduct thorough functionality testing, security, and
                performance to get a bug-free application.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4 mb-md-0">
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">07</div>
                <div className="cms-service-head">
                  <h5>Data Migration Stage</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>
                Ensure seamless data transfer from legacy systems to the new
                CMS, maintaining data integrity.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">08</div>
                <div className="cms-service-head">
                  <h5>Deployment & Support</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>
                Deploy the CMS, provide user training, ongoing support, regular
                updates, and performance monitoring.
              </p>
            </div>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Talk to Our Experts
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Cmsserviceworkflow;
